import MUIStep from '@mui/material/Step';
import MUIStepButton from '@mui/material/StepButton';
import MUIStepper from '@mui/material/Stepper';
import { Box, styled } from '@mui/material';

export const BarStepperRoot = styled(MUIStepper)`
  height: 15px;
  width: 100%;
  justify-content: center;
  gap: 13px;

  .MuiStepper-root {
    justify-content: center;
  }

  .MuiStep-root {
    padding: 0;
    justify-content: center;
    width: 100%;
  }

  .MuiStepConnector-root {
    display: none;
  }
`;

export const BarStep = styled(MUIStep)`
  .MuiStepLabel-iconContainer {
    padding-right: 0px;
    width: 100%;
    .MuiSvgIcon-root .MuiStepIcon-text {
      display: none;
    }
  }

  .MuiStepLabel-root {
    width: 100%;
  }

  .MuiStepLabel-labelContainer {
    display: none;
  }

  :last-of-type .MuiStepLabel-iconContainer {
    padding-right: 0px;
  }

  :last-of-type .icon-e {
    margin-right: 0px;
  }
`;

export const BarStepButton = styled(MUIStepButton)`
  padding: 0px;
  margin: 0px;
`;

export const BarStepButtonIcon = styled(Box)`
  width: 100%;
  height: 7px;
  border-radius: 2rem;
  background: #eee;
  position: relative;
  margin-right: 0px;
`;

export const BarStepButtonIconE = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'fullWidth',
})<{
  fullWidth?: boolean;
}>`
  width: ${(props) => (props.fullWidth ? `100%` : `28px`)};
  height: 7px;
  border-radius: 2rem;
  background: #000000;
  position: absolute;
  left: 0;
  top: 0;
`;
